import { OrganizationInfo } from "@/pages/organisaties/gegevens/OrganizationInfo"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/organisatie-profiel/gegevens/")({
  component: OrganizationOverview,
})

function OrganizationOverview() {
  return <OrganizationInfo />
}
